import gsap, { Power1, Power3 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import Header from "./Header";
import TexturesController from "../_app/cuchillo/3D/TexturesController";
import Logo from "./Logo";

export default class Preloader {
    _container;
    _progress;
    _name;
    _callback;
    _isShow = false;
    _isLoaded = false;


    
    static init (__call) {
        this._callback = __call;
        this._container = GetBy.id('Preloader');  
        this._progress = GetBy.class('progress', this._container)[0];   
        this._name = GetBy.selector('span', this._progress)[0];   
               // setTimeout(()=> {
           

            TexturesController.start({call:()=>{
                
                TexturesController.isPreload = false;
                this._isLoaded = true;
                
                if(this._isShow) {
                    this.hide();
                }
                

                /*setTimeout(()=> {   CircleSlider.getInstance().preshow(); }, 1500);
                setTimeout(()=> {   Header.show(5);}, 3000);
                setTimeout(()=> {   this._callback()}, 6000);*/
            }});


        this.show();
        //}, 500);
        

      //  this._callback = __call;
      //  this._container = GetBy.id('Preloader');        
    }

    static show() {
        gsap.to(this._progress, {
            opacity: 1,
            ease: Power3.easeIn,
            duration: .4,
            delay:.1,
        });

        gsap.to(this._name, {
            opacity: 1,
            ease: Power3.easeIn,
            duration: .6,
            delay:.1,
            onComplete:() => {
                setTimeout(()=> {
                    this._isShow = true;
                    if(this._isLoaded) {
                        this.hide();
                    }
                }, 1000);
            }
        });
    }

    static update (__progress) {

    }

    static hide (__call) {
        gsap.to(this._name, {
            opacity: 0,
            ease: Power3.easeOut,
            duration: .4,
            delay:.1
        });

        gsap.to(this._progress, {
            opacity: 0,
            ease: Power3.easeOut,
            duration: .6,
            delay:.1,
            onComplete:() => {
                setTimeout(()=> {
                    this._container.style.display = "none";
                    Logo.show(()=> {this._callback()})        
                }, 300);
            }
        });
    }
}
